(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chronoera-watch-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chronoera-watch-ui')) {
    customElements.define('chronoera-watch-ui', class extends HTMLElement {
      connectedCallback() {
        this.root = document.body;
        if (!this.root) return;
        this.formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: 'EUR' });
        this.refresh = () => {
          this.pending = false;
          this.root.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(button => {
            if (/^buy it now$/i.test(button.textContent.trim())) button.textContent = this.dataset.buyNow.trim();
          });
          if (this.dataset.currency !== 'EUR') return;
          this.root.querySelectorAll('product-price .price, product-price .compare-at-price, .buy-me-price, .buy-me-compare-price').forEach(node => {
            const original = node.textContent.trim();
            if (!/€|EUR/.test(original) || node.children.length) return;
            const raw = original.replace(/EUR|€|\s/g, '');
            if (!/^\d[\d.,]*$/.test(raw)) return;
            const decimal = raw.match(/[.,](\d{2})$/);
            const amount = decimal ? Number(raw.slice(0, -3).replace(/[.,]/g, '') + '.' + decimal[1]) : Number(raw.replace(/[.,]/g, ''));
            if (!Number.isFinite(amount)) return;
            const formatted = this.formatter.format(amount);
            if (node.textContent !== formatted) node.textContent = formatted;
          });
        };
        this.observer = new MutationObserver(() => {
          if (this.pending) return;
          this.pending = true;
          this.frame = requestAnimationFrame(this.refresh);
        });
        this.observer.observe(this.root, { childList: true, subtree: true, characterData: true });
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
